import { PecDTO } from "./pecDTO";
import { ApaciDTO } from "./apaciDTO";
import { MailDTO } from "./mailDTO";
import { PortaleWebDTO } from "./portale-webDTO";
import { CartaceoDTO } from "./cartaceoDTO";

export class RicercaRecapitoDTO {
  descrizione: string;

  pec: PecDTO;

  apaci: ApaciDTO;

  mail: MailDTO;

  portaleWeb: PortaleWebDTO;

  cartaceo: CartaceoDTO;

  idSoggetto: number;

  idRecapito: number;
}
